/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Plan
 */
export interface Plan {
    /**
     * Plan code / tier identifier.
     * @type {string}
     * @memberof Plan
     */
    code: PlanCodeEnum;
    /**
     * Optional human-friendly name.
     * @type {string}
     * @memberof Plan
     */
    displayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Plan
     */
    description?: string | null;
}


/**
 * @export
 */
export const PlanCodeEnum = {
    Free: 'free',
    Paid: 'paid'
} as const;
export type PlanCodeEnum = typeof PlanCodeEnum[keyof typeof PlanCodeEnum];


/**
 * Check if a given object implements the Plan interface.
 */
// @ts-ignore
export function instanceOfPlan(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "code" in value;

    return isInstance;
}

// @ts-ignore
export function PlanFromJSON(json: any): Plan {
    return PlanFromJSONTyped(json, false);
}

// @ts-ignore
export function PlanFromJSONTyped(json: any, ignoreDiscriminator: boolean): Plan {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
        'displayName': !exists(json, 'display_name') ? undefined : json['display_name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

// @ts-ignore
export function PlanToJSON(value?: Plan | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'display_name': value.displayName,
        'description': value.description,
    };
}

